module.exports = __webpack_public_path__ + "media/images/discover/logos/discover_airlines_rgb_white_1line-f1a35890514768974f9172cf8be8deec.svg";